import { Component, ViewChild, ElementRef, HostListener, ChangeDetectorRef } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { Table } from 'primeng/table';
import { ToastService } from 'src/app/core/services/toast.service';
import { UserProfileService } from 'src/app/core/services/user.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmModalService } from 'src/app/core/services/confirm-modal.service';
@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrl: './user.component.scss'
})
export class UserComponent {
  users: any[] = [];
  loading: boolean = false;
  modalRef!: NgbModalRef;
  totalRecords = 0;
  rows = 10;
  searchText = '';
  selectedStatus: string = '';
  userDetail: any = {};
  rangeDates: Date[] | null = null;

  statusOptions = [
    { label: 'All', value: '' },
    { label: 'Pending', value: 'PENDING' },
    { label: 'Active', value: 'ACTIVE' },
    { label: 'Rejected', value: 'REJECTED' },
  ];

  @ViewChild('dt') table!: Table;
  @ViewChild('stateDropdown') stateDropdown!: ElementRef;

  constructor(
    private userService: UserProfileService,
    private modalService: NgbModal,
    private toastService: ToastService,
    private cdr: ChangeDetectorRef,
    private confirmModalService: ConfirmModalService
  ) { }


  getUsers(event: LazyLoadEvent) {
    this.loading = true;
    this.cdr.detectChanges();

    const first = event?.first ?? 0;
    const rows = event?.rows ?? this.rows;
    const page = first / rows + 1;
    let startDate: string | null = null;
    let endDate: string | null = null;

    if (this.rangeDates?.length === 2) {
      startDate = this.formatDate(this.rangeDates[0]);
      endDate = this.formatDate(this.rangeDates[1]);
    }

    const queryParams = {
      page,
      limit: rows,
      search: this.searchText,
      status: this.selectedStatus,
      startDate,
      endDate
    };
    this.userService.getUsers(queryParams).subscribe({
      next: (res: any) => {
        this.users = res?.data || [];
        this.totalRecords = res?.totalCount || 0;
        this.loading = false;

        this.cdr.detectChanges();
      },
      error: () => {
        this.loading = false;
        this.cdr.detectChanges();
      }
    });
  }

  formatDate(date: Date): string {
    const y = date.getFullYear();
    const m = (date.getMonth() + 1).toString().padStart(2, '0');
    const d = date.getDate().toString().padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  filterChange(event: any) {
    this.selectedStatus = event.status;
    this.searchText = event.search;
    this.rangeDates = event.dateRange
    this.table?.reset();
  }

  openEditModal(user: any, content: any) {

    this.userService.getUserDetail(user?._id).subscribe({
      next: (res: any) => {
        this.userDetail = res?.data;
        this.modalRef = this.modalService.open(content, { size: 'md' });
      },
      error: () => { }
    });
  }

  closeModal() {
    if (this.modalRef) {
      this.modalRef.dismiss();
      this.userDetail = {};
    }
  }

  toggleUserStatus(user: any, event: Event) {
    const input = event.target as HTMLInputElement;
    const checked = input.checked;

    const newStatus: 'Active' | 'Inactive' = checked ? 'Active' : 'Inactive';
    const confirmMessage =
      newStatus === 'Active'
        ? 'Are you sure you want to activate this user?'
        : 'Are you sure you want to deactivate this user?';

    if (!confirm(confirmMessage)) {
      input.checked = user.status !== 'Inactive';
      return;
    }

    if (user.status === newStatus) {
      return;
    }

    const payload: Partial<any> = {
      status: newStatus
    };

    // this.userService.deactivateCustomer(user._id, payload).subscribe({
    //   next: () => {
    //     this.loadCustomers({ first: 0, rows: this.rows });
    //     this.toastService.showToaster(
    //       'Success',
    //       `Customer ${newStatus === 'Active' ? 'activated' : 'deactivated'} successfully`,
    //       'success'
    //     );
    //   },
    //   error: (err) => {
    //     input.checked = user.status !== 'Inactive';
    //     const message =
    //       err || 'Unable to update user status';
    //     this.toastService.showToaster('Failed', message, 'error');
    //   }
    // });
  }

  selectedStateIds: string[] = [];
  selectedStateNames: string[] = [];
  states: any[] = [];
  showDropdown: boolean = false;

  onStateChange(event: any, state: any): void {

    if (event.target.checked) {

      if (!this.selectedStateIds.includes(state._id)) {
        this.selectedStateIds.push(state._id);
      }

      if (!this.selectedStateNames.includes(state.name)) {
        this.selectedStateNames.push(state.name);
      }

    } else {

      this.selectedStateIds =
        this.selectedStateIds.filter(
          id => id !== state._id
        );

      this.selectedStateNames =
        this.selectedStateNames.filter(
          name => name !== state.name
        );
    }
  }

  approvedStates(): void {
    const id = this.userDetail?._id;

    if (!id) {
      this.toastService.showToaster(
        'Failed',
        'User detail not found',
        'error'
      );
      return;
    }

    this.closeModal();

    setTimeout(() => {
      this.confirmModalService.open(
        'Approve User',
        'Are you sure you want to approve this user?',
        () => {
          this.confirmApproveUser(id);
        },
        'Approve',
        'Cancel'
      );
    }, 100);
  }
  confirmApproveUser(id: string): void {
    this.loading = true;
    this.userService.approvedStates(id).subscribe({
      next: (res: any) => {
        // this.closeModal();
        this.loading = false;
        this.getUsers({ first: 0, rows: this.rows });
        this.toastService.showToaster(
          "Success",
          res?.message || "User approved successfully",
          "success"
        );
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  selectedAction: 'APPROVE' | 'REJECT' = 'APPROVE';
  rejectMessage: string = '';

  rejectedStateReq(): void {
    if (!this.rejectMessage?.trim()) {
      this.toastService.showToaster(
        'Validation',
        'Please enter reject reason',
        'info'
      );
      return;
    }

    const payload = {
      userId: this.userDetail?._id,
      message: this.rejectMessage.trim()
    };

    if (!payload.userId) {
      this.toastService.showToaster(
        'Failed',
        'User detail not found',
        'error'
      );
      return;
    }

    this.closeModal();

    setTimeout(() => {
      this.confirmModalService.open(
        'Reject User',
        'Are you sure you want to reject this user?',
        () => {
          this.confirmRejectUser(payload);
        },
        'Reject',
        'Cancel'
      );
    }, 100);
  }

  confirmRejectUser(payload: any): void {
    this.userService.rejectedStateReq(payload).subscribe({
      next: (res: any) => {
        // this.closeModal();
        this.getUsers({ first: 0, rows: this.rows });
        this.rejectMessage = '';
        this.selectedAction = 'APPROVE';

        this.toastService.showToaster(
          "Success",
          res?.message || "User rejected successfully",
          "success"
        );
      },
      error: () => { }
    });
  }

  getStates() {
    this.userService.getStates(this.userDetail.role).subscribe((res: any) => {
      this.states = res?.data || [];
    }, () => { })
  }



}
